<template>
    <v-app-bar fixed color="primary" hide-on-scroll scroll-target="" app  tile flat class="bottom-bordered">
        <v-text-field label="Search" flat solo outlined color="grey" dense hide-details tile prepend-inner-icon="mdi-magnify" @click="$router.push('/search/')"></v-text-field>
        <!-- <template v-slot:extension class="px-0">
            <v-chip-group multiple>
                <v-chip v-for="tag in tags" :key="tag">
                    {{ tag }}
                </v-chip>
            </v-chip-group>
        </template> -->
    </v-app-bar>
</template>
<script>
export default {
    data: () => ({
        tags: [
            'Project',
            'Video',
            'Photos',
            'Plans', 
            'Filter1',
            'Filter2',
            'Filter3',
            'Filter4',
        ],
    }),
}
</script>